import { useCallback, useState, useEffect } from "react";

const usePostTransactionSubscription = () => {
    const [postError, setPostError] = useState(null);
    const [subscriptionResponse, setSubscriptionResponse] = useState(null);

    // Extract environment variables outside the callback for consistency
    const POST_EDI_TRANSACTION_SUBSCRIPTION = process.env.REACT_APP_POST_EDI_TRANSACTION_SUBSCRIPTION;
    const APIKEY = process.env.REACT_APP_APIKEY;

    // Ensure environment variables are available
    useEffect(() => {
        if (!POST_EDI_TRANSACTION_SUBSCRIPTION || !APIKEY) {
            setPostError(new Error("Required environment variables are missing"));
        }
    }, [POST_EDI_TRANSACTION_SUBSCRIPTION, APIKEY]);

    const postTransactionSubscription = useCallback(async (requestPayload) => {
        if (!POST_EDI_TRANSACTION_SUBSCRIPTION || !APIKEY) {
            console.log("env variables missing {0}, {1}", POST_EDI_TRANSACTION_SUBSCRIPTION, APIKEY)
            return; // Return early if environment variables are missing
        }

        try {

            console.log("payload passed to hook", JSON.stringify(requestPayload))

            const response = await fetch(POST_EDI_TRANSACTION_SUBSCRIPTION, {
                method: "POST",
                headers: {
                    "x-api-key": APIKEY,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestPayload),
            });

            if (!response.ok) {
                const errorData = await response.text();
                throw new Error(`Network error: ${response.status} - ${response.statusText}. Details: ${errorData}`);
            }

            const data = await response.json();
            setSubscriptionResponse(data);  // Update response state only on success
            console.log("subscription response: ", subscriptionResponse)
        } catch (error) {
            console.error("Error posting subscription:", error);
            setPostError(error);  // Set error state
        }
    }, [POST_EDI_TRANSACTION_SUBSCRIPTION, APIKEY]);

    return { postTransactionSubscription, subscriptionResponse, postError };
};

export default usePostTransactionSubscription;
